import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_3f5f1ef2 from 'nuxt_plugin_plugin_3f5f1ef2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_clipboard_c0df0a06 from 'nuxt_plugin_clipboard_c0df0a06' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_5105b3c5 from 'nuxt_plugin_cookieuniversalnuxt_5105b3c5' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_832c23c6 from 'nuxt_plugin_axios_832c23c6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_windowfunction_6575bdb6 from 'nuxt_plugin_windowfunction_6575bdb6' // Source: ../plugins/window-function.js (mode: 'client')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_libflexible_1aeae207 from 'nuxt_plugin_libflexible_1aeae207' // Source: ../plugins/lib-flexible (mode: 'client')
import nuxt_plugin_vconsole_72441615 from 'nuxt_plugin_vconsole_72441615' // Source: ../plugins/vconsole (mode: 'client')
import nuxt_plugin_g2_170fd4c2 from 'nuxt_plugin_g2_170fd4c2' // Source: ../plugins/g2 (mode: 'client')
import nuxt_plugin_commom_1740b917 from 'nuxt_plugin_commom_1740b917' // Source: ../plugins/commom.js (mode: 'client')
import nuxt_plugin_router_79dc5b58 from 'nuxt_plugin_router_79dc5b58' // Source: ../plugins/router.js (mode: 'client')
import nuxt_plugin_bus_caead7e8 from 'nuxt_plugin_bus_caead7e8' // Source: ../plugins/bus (mode: 'client')
import nuxt_plugin_vant_925e8cb6 from 'nuxt_plugin_vant_925e8cb6' // Source: ../plugins/vant (mode: 'all')
import nuxt_plugin_ga_170fd464 from 'nuxt_plugin_ga_170fd464' // Source: ../plugins/ga (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"艺考志愿星","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"},{"name":"keywords","content":"艺考志愿星,艺术类志愿填报,志愿填报系统,志愿填报指南,艺术类考生志愿填报app,艺考生怎么报志愿,艺考生志愿填报实例"},{"name":"description","content":"艺术类考生高考志愿怎么填,2023艺考生怎样填报志愿,艺考生可以填几个志愿,艺考生填志愿,艺术考生怎样填报志愿,艺考生如何填志愿"},{"name":"format-detection","content":"telephone=no"},{"name":"referrer","content":"always"}],"script":[{"src":"\u002Fjs\u002Funi.webview.1.5.4.js","async":true,"defer":false},{"innerHTML":"window.onload = function() {\n          \u002F\u002F 页面加载完成后的代码\n          console.log('页面已加载完成！');\n           window.uni.postMessage({\n              data: {\n                name: 'loaded'\n              }\n            })\n            window.uni.postMessage({\n              data: {\n                name: 'checkEnvAvailable'\n              }\n            })\n      };\n      ","type":"text\u002Fjavascript","charset":"utf-8"},{"innerHTML":"apiready = function() {window.api = api;}","type":"text\u002Fjavascript","charset":"utf-8"},{"innerHTML":"function loadJS(url, callback) {\n          var script = document.createElement('script'), fn = callback || function() {\n          };\n          script.type = 'text\u002Fjavascript';\n          \u002F\u002F IE\n          if (script.readyState) {\n              script.onreadystatechange = function() {\n                  if (script.readyState == 'loaded'\n                          || script.readyState == 'complete') {\n                      script.onreadystatechange = null;\n                      fn();\n                  }\n              };\n          } else {\n              \u002F\u002F 其他浏览器\n              script.onload = function() {\n                  fn();\n              };\n          }\n          script.src = url;\n          document.getElementsByTagName('head')[0].appendChild(script);\n      };\n      var userAgent = navigator.userAgent;\n        if (\u002Fmicromessenger\u002Fi.test(userAgent)) {\n          loadJS('https:\u002F\u002Fres.wx.qq.com\u002Fopen\u002Fjs\u002Fjweixin-1.4.0.js');\n        }else if (userAgent.indexOf('AlipayClient') \u003E -1) {\n          loadJS('https:\u002F\u002Fappx\u002Fweb-view.min.js');\n        }else if (\u002Ftoutiaomicroapp\u002Fi.test(userAgent)) {\n          loadJS('https:\u002F\u002Flf1-cdn-tos.bytegoofy.com\u002Fgoofy\u002Fdeveloper\u002Fjssdk\u002Fjssdk-1.1.0.js');\n        }else if (\u002Fswan\u002Fi.test(userAgent)) {\n          loadJS('https:\u002F\u002Fb.bdstatic.com\u002Fsearchbox\u002Ficms\u002Fsearchbox\u002Fjs\u002Fswan-2.0.29.js');\n        }","type":"text\u002Fjavascript","charset":"utf-8"}],"__dangerouslyDisableSanitizers":["script"],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3f5f1ef2 === 'function') {
    await nuxt_plugin_plugin_3f5f1ef2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_c0df0a06 === 'function') {
    await nuxt_plugin_clipboard_c0df0a06(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5105b3c5 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5105b3c5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_832c23c6 === 'function') {
    await nuxt_plugin_axios_832c23c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_windowfunction_6575bdb6 === 'function') {
    await nuxt_plugin_windowfunction_6575bdb6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libflexible_1aeae207 === 'function') {
    await nuxt_plugin_libflexible_1aeae207(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_72441615 === 'function') {
    await nuxt_plugin_vconsole_72441615(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_g2_170fd4c2 === 'function') {
    await nuxt_plugin_g2_170fd4c2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_commom_1740b917 === 'function') {
    await nuxt_plugin_commom_1740b917(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_router_79dc5b58 === 'function') {
    await nuxt_plugin_router_79dc5b58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bus_caead7e8 === 'function') {
    await nuxt_plugin_bus_caead7e8(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_925e8cb6 === 'function') {
    await nuxt_plugin_vant_925e8cb6(app.context, inject)
  }

  if (typeof nuxt_plugin_ga_170fd464 === 'function') {
    await nuxt_plugin_ga_170fd464(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
